import { useTranslation } from "react-i18next"
import { useDownload } from "../../../../../../../../hooks/download/useDownload"
import { loogbookServiceFetch } from "../../../../../../../../utils/constants/callService"
import { returnQueryWithPagination } from "../../../../../../../../utils/methods/returnQuery"
import { TableActions } from "../../tableActions"
import { useLogbookContext } from "../../../../context"
import { Hashs } from "../../../activityRegister/utils"
import { formatUserMapFilter, QueryActivity } from "../../../../utils"
import { useLocation } from "react-router-dom"
import { UserSection } from "../../../../utils/enums/userSection"
import { useEffect } from "react"
import { LinearProgressDownload } from "../linearProgressDownload"

export const UserListActivityAction = () => {
    const { filter: { filterListUser: { filter }, filterOneUser, filterUser }, service: { getDetailInform }, state: { uuid, loading }, setVisibleUsersDataByUser } = useLogbookContext()
    const { t } = useTranslation()
    const location = useLocation()
    const queary = new URLSearchParams(location.search)
    const usersIds: string = queary.get(QueryActivity.IDS) ?? ''
    const areThereSomeUser = !!filter.filterData?.user?.length
    const query = `${!areThereSomeUser ? `&user_ids=${usersIds}` : ''}${returnQueryWithPagination({ filter: filter.filterString }, formatUserMapFilter)}`
    const downloadCustome = () => {
        getDetailInform({ query: query, uuidTab: UserSection.USER_LIST_ACTIVITY })
    }
    const cleanFilterAll = () => {
        filter.cleanFilter()
        filterOneUser.filter.cleanFilter()
        filterUser.filter.cleanFilter()
        setVisibleUsersDataByUser({})
    }
    const {
        download,
        openSnackbar,
        downloadCSV,
        downloadPDF,
        downloadWORD,
        closeOpenSnakbar
    } = useDownload({
        query: query,
        docName: t('loogbook.activity'),
        downloadFuntion: loogbookServiceFetch.downloadLogbook,
    })

    useEffect(() => {
        if (uuid.USER_LIST_ACTIVITY) {
            const interval = setInterval(() => {
                getDetailInform({ query, uuidTab: UserSection.USER_LIST_ACTIVITY });
            }, 30000);
            return () => clearInterval(interval);
        }
    }, [uuid.USER_LIST_ACTIVITY])
    return (<>
        <LinearProgressDownload show={loading.USER_LIST_ACTIVITY} text={t('loogbook.generateDetailInform')} />
        <TableActions
            download={{
                csv: downloadCSV,
                pdf: downloadPDF,
                word: downloadWORD,
                disableCSV: download?.excel,
                disablePDF: download?.pdf,
                disableWORD: download?.word
            }}
            count={filter.counter}
            cleanActivityButton={{ onClick: cleanFilterAll }}
            downloadCustome={downloadCustome}
            downloadDisabled={{ 'pdf-detail': loading.USER_LIST_ACTIVITY, excel: false, pdf: false, word: false }}
            closeOpenSnakbar={closeOpenSnakbar}
            openSnackbar={openSnackbar}
            addActivityButton={{ onClick: () => { window.location.hash = Hashs.CREATE } }}
        />
    </>)
}